<template>
    <b-container class="p-0" style="width: auto;">
        <b-button-group :id="id" class="yes-no-control">

            <b-button id="yes-btn"
                      :class="isTrue() ? 'yes-no-active' : ''"
                      class="yes-no-btn"
                      :disabled="isDisabled"
                      @click="yesClick">
                {{textYes}}
            </b-button>

            <b-button id="no-btn"
                      class="yes-no-btn"
                      :class="isFalse() ? 'yes-no-active' : ''"
                      :disabled="isDisabled"
                      @click="noClick">
                {{textNo}}
            </b-button>

        </b-button-group>
    </b-container>
</template>

<script>

import '@/assets/styles/shared/yesNoInput.css'

export default {
    model: {
        prop: 'value',
        event: 'click'
    },
    props: {
        id: { 
            type: String,
            default: function(){
                return 'yes-no-' + Math.round(Math.random() * 10000);
            }
        },
        value: {
            type: [Object, Boolean, String],
            default: null
        },		
        textYes: {
            type: String,
            default: 'Да'
        },
        textNo: {
            type: String,
            default: 'Нет'
        },
        isDisabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        isTrue: function() {
            return this.value === true || this.value === 'true';
        },
        isFalse: function() {
            return this.value === false || this.value === 'false';
        },
        yesClick: function () {
            if (!this.value || this.value == null || this.value === "")
                this.$emit('click', true);
            else
                this.$emit('click', null);
        },
        noClick: function () {
            if (this.value || this.value == null || this.value === "")
                this.$emit('click', false);
            else
                this.$emit('click', null);
        }
    }
}
</script>